// extracted by mini-css-extract-plugin
export default {"publicEnrollment":"PublicEnrollment_publicEnrollment__n-kEO","error":"PublicEnrollment_error__5DsKv"};